export const mutations = {
  addMileageItems(state) {
    state.mileage_items.push({
      driver_id: "",
      truck_id: "",
      mileage_amount: "",
      turn_boy: "",
      location_id: "",
      destination_id: "",
      consignment: "",
      remark: ""

    });
  },

  STORE_MILEAGES(state, mileages) {
    state.mileages = mileages;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/mileages/mutations.js